import * as React from 'react';
import { format } from 'date-fns';
import t from './locales';

type IDateField = {
  selectedDateList: Date[],
  handleClick: () => void,
}

const DateField: React.FC<IDateField> = (props) => {
  const { selectedDateList, handleClick } = props;
  const fromTo = (selectedDateList.length > 1
    ? [selectedDateList[0], selectedDateList[selectedDateList.length - 1]]
    : [selectedDateList[0]]) 
    .filter(date => !!date)
    .map(date => format(date, 'yyyy-MM-dd'))
    .join(' - ');
  return (
    <input onClick={handleClick} readOnly value={fromTo === '' ? t.pleaseSelect() : fromTo} />
  );
};

export default DateField;
